import React, { Fragment } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import _ from 'lodash'
import EditBtn from '../../buttons/EditBtn'
import { mssgs } from '../../../constantes/mssgs'

const BusinessUnitsList = ({
  allBusinessUnits,
  handleRemove,
  openEditModal,
}) => {
  allBusinessUnits = _.orderBy(allBusinessUnits, ['nombre'], ['asc'])
  // console.log('allBusinessUnits', allBusinessUnits)
  return (
    <>
      <Fragment>
        <table>
          <thead>
            <tr>
              {/* <th>
                <h4 className="products__sub">ID</h4>
              </th> */}
              <th>
                Nombre
              </th>
              <th>
                Descripción
              </th>
              <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {allBusinessUnits?.length > 0 ? (
              allBusinessUnits?.map((businessUnit, i) => (
                <tr key={i}>
                  {/* <td>
                    <p className="products__text">{businessUnit.id_NegocioUnidad}</p>
                  </td> */}
                  <td className="table-td-header">
                    {businessUnit.nombre}
                  </td>
                  <td className="table-td-header">
                    {businessUnit.descripcion}
                  </td>
                  <td className="table-td-actions">
                        <button onClick={() => openEditModal(businessUnit)}>
                          <EditBtn />
                        </button>
                        <button
                          onClick={() =>
                            handleRemove(businessUnit.id_NegocioUnidad)
                          }
                        >
                          <DeleteBtn />
                        </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3">
                  <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_UNIDADES_NEGOCIO} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Fragment>
    </>
  )
}

export default BusinessUnitsList
